import { useTsController } from '@ts-react/form';
import classNames from 'classnames';

type Props = {
  name: string;
  type: 'textarea' | 'input';
  label?: string;
  secondLabel?: string;
  placeholder?: string;
  max?: number;
  min?: number;
  autoFocus?: boolean;
};

export default function TextField({
  max,
  min,
  label,
  name,
  secondLabel,
  placeholder,
  type,
  autoFocus,
}: Props) {
  const { field, error } = useTsController<string>();

  if (type === 'textarea') {
    return (
      <div>
        <label htmlFor={name} className="mb-4 flex flex-col text-sm text-black">
          <span>{label}</span>
          {secondLabel ? (
            <span className="text-xs text-black/75">{secondLabel}</span>
          ) : null}
        </label>
        <div className="mt-1">
          <textarea
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
            rows={4}
            maxLength={max}
            minLength={min}
            name={name}
            id={name}
            placeholder={placeholder}
            autoFocus={autoFocus}
            // className="p-1 rounded-md border shadow-sm focus-within:ring-2 border-accent focus-within:ring-primary focus-within:border-primary"
            className="border-primary/50 ring-primary w-full resize-none rounded-md border-2 px-3 py-2 text-sm placeholder-black/50 outline-none transition-all focus:ring-2 focus:ring-offset-2"
          />
        </div>
        <span className={classNames({ invisible: !error }, 'text-xs')}>
          {error?.errorMessage ?? 'error'}
        </span>
      </div>
    );
  }

  return (
    <div>
      <label htmlFor={name} className="flex flex-col p-1 text-sm font-medium">
        <span>{label}</span>
        {secondLabel ? (
          <span className="text-xs text-black/75">{secondLabel}</span>
        ) : null}
      </label>
      <input
        type="text"
        name={name}
        id={name}
        max={max}
        value={field.value}
        onChange={(e) => field.onChange(e.target.value)}
        className="ring-primary block w-full rounded-md px-3 py-2 text-black placeholder-gray-500 outline-none transition-all focus:ring-2 sm:text-sm"
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
      <span
        className={classNames(
          { invisible: !error?.errorMessage },
          'mt-1 text-xs',
        )}
      >
        {error?.errorMessage ?? 'error'}
      </span>
    </div>
  );
}
